import React, { useState } from 'react';
import { Field, FieldArray } from 'formik';
import APICall from '../../helpers/api';
import styled from '@emotion/styled';
import P from 'prop-types';
import axios from 'axios';
import Progress from './Progress';
import { connect} from 'react-redux';
import { newErrorNotificationAction } from '../../modules/notifications/Actions';

const MultiUpload = (props) => {
  const { name, label, limitDimensions, S3Bucket = 'warshatna-users', API, data, disabled, errorMsg ,picNumber } = props;

  const [upload, setUpload] = useState(0);
  const [max, setMax] = useState(0);
  const [showProgress, setShowProgress] = useState(false);
  const [error, setError] = useState(null);

  // S3Bucket = bp-ca-artisans
  // API      = artisan/artisan-category-signedurl/
  // data     = {artisanID : 'id'}
  // name     = categoryImage
  // console.log({S3Bucket}, {API}, {name})

  return (
    <FieldArray name={name}>
      {({ move, remove, push, insert, unshift, pop, form, name }) => {
        const { setFieldValue, values } = form;

        const fileLabel = 'Choose Image';

        /*         const checkWidthAndHeight = file => {
          return new Promise((resolve, reject) => {
            const src = URL.createObjectURL(file);
            const image = new Image();
            image.src = src;
            image.onload = () => {
              if (
                image.width >= limitDimensions.width ||
                image.height >= limitDimensions.height
              ) {
                reject(
                  `limits are ${limitDimensions.width}/${limitDimensions.height}`
                );
              } else {
                resolve("done");
              }
              URL.revokeObjectURL(src);
            };
          });
        }; */

        const handleUpload = async (files) => {
          // ??
          console.log(files)
          setError(null);
          if (Array.isArray(values[name]) && values[name].length >= 3) {
            setError('selected images must be less than 4');
            errorMsg('selected images must be less than 4');

            return;
          }
          for (let i = 0; i < files.length; i++) {
            if (files[i].size > 1000000) {
              setError('The image is too big!. it must be less than 1 MB');
              errorMsg('The image is too big!. it must be less than 1 MB');
              return;
            }
            if (
              files[i].type !== 'image/png' &&
              files[i].type !== 'image/jpeg' 
            ) {
              setError(
                'you can only upload photos in png/jpeg format'
              );
              errorMsg(
                'you can only upload photos in png/jpeg format'
              );
              continue;
            }

            setUpload(0);
            setMax(0);

            const uploadConfig = await APICall.post(API, data);

            setShowProgress(true);

            try {
              await axios.put(uploadConfig.data.url, files[i], {
                onUploadProgress: (ProgressEvent) => {
                  setMax(ProgressEvent.total);
                  setUpload(ProgressEvent.loaded);
                },
                headers: {
                  'Content-Type': files[i].type,
                },
              });

              push({
                // imagePath: `https://${S3Bucket}.s3.amazonaws.com/${uploadConfig.data.key}`,
                imagePath: `https://${S3Bucket}.s3.eu-central-1.amazonaws.com/${uploadConfig.data.key}`,
                shortDesc: '',
                longDesc: '',
                featured: false,
              });
            } catch (error) {
              setError(error.message);
            } finally {
              setShowProgress(false);
            }
          }

          // ckecking the file type

          // ckecking the image width and height
          /*           if (limitDimensions) {
            try {
              await checkWidthAndHeight(file);
            } catch (error) {
              setError(error);
              return;
            }
          } */
        };

        return (
          <div className="form-group">
            <label className="" htmlFor={name}>
              {label}
            </label>

            <FieldContainer className="col-12">
              <input
                disabled={disabled}
                multiple={true}
                className="custom-file-input"
                type="file"
                accept="image/png, image/jpeg"
                onChange={(e) => handleUpload(e.target.files)}
              />
              {showProgress && <Progress value={upload} max={max} />}

              {values[name] && values[name].length > 0 && (
                <FileList>
                  {values[name].map(({ firstName, lastName }, index) => (
                    <File key={index}>
                      <Field name={`${name}[${index}].imagePath`}>
                        {({ form, field }) => {
                          return (
                            <IMG>
                              <img src={field.value} />
                            </IMG>
                          );
                        }}
                      </Field>
                      <button
                        className="btn btn-sm btn-label-danger"
                        disabled={disabled}
                        style={{ alignSelf: 'center' }}
                        type="button"
                        onClick={(e) => {
                          remove(index);
                        }}
                      >
                        <i
                          className="flaticon-delete"
                          style={{ marginRight: '0px' }}
                        ></i>
                      </button>
                    </File>
                  ))}
                </FileList>
              )}
              <FileLabel className="custom-file-label">{fileLabel}</FileLabel>

              {/*             <button onChange={() => push('hi')}>add</button>
               */}

              {/*               {error && <TextError className='error'>{error}</TextError>}
               */}
              {/*               {showProgress && <Progress value={upload} max={max} />}
                {values[name] && (values[name]).map(img => (
                    <img key={img._id} src={img.imagePath} />
            ))} */}

              {/*   {value && (
                <FileList>
                  {
                    //
                    // I should render the image only by now!
                    // the image is a part of the object
                    //
                  }
                  <File target='_blank' rel='noopener noref errer' href={value}>
                    <img
                      src={value}
                      alt='company logo'
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </File>

                  {
                    // delete button should delete the item from the array
                  }

                  <button
                    className='btn btn-sm btn-label-danger'
                    style={{ alignSelf: "center" }}
                    onClick={(e) => {
                      e.preventDefault();
                      setFieldValue("field.name", "");
                      setError(null);
                    }}
                  >
                    <i
                      className='flaticon-delete'
                      style={{ marginRight: "0px" }}
                    ></i>
                  </button>
                  {
                    // End of Delete Button
                  }
                </FileList>
              )} */}
            </FieldContainer>
          </div>
        );
      }}
    </FieldArray>
  );
};

MultiUpload.prototype = {
  name: P.string.isRequired,
  S3Bucket: P.string.isRequired,
  API: P.string.isRequired,
  data: P.object.isRequired,
  label: P.string,
  limitDimensions: P.shape({
    width: P.number,
    height: P.number,
  }),
};

MultiUpload.defaultProps = {
  label: '',
  limitDimensions: null,
};

const TextError = styled.span`
  color: red;
`;

const FieldContainer = styled.div`
  position: relative;
  padding-bottom: '15px';
  width: 100%;
`;

// changed margin left and right from 10px to 0px

const FileLabel = styled.label`
  margin-left: 0px;
  margin-right: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FileList = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  margin: 5px;
  flex-direction: column;
`;

const File = styled.div`
  border-bottom: 1px solid #f7ebeb;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  &:last-child {
    border-bottom: none;
  }
`;

const IMG = styled.a`
  width: 100px;
  height: 100px;
  background-color: transparent;
  border: 1px solid #ccccce;
  padding: 4px;
  cursor: pointer;
  transition: background-color 0.5s;
  &:hover {
    background-color: #ffef058a;
  }
  & img {
    width: 100%;
    height: 100%;
  }
`;

const mapDispatchToProps = {
  errorMsg: newErrorNotificationAction,
}

export default connect(null, mapDispatchToProps)(MultiUpload);
